export enum WIDGET_STATUS {
  DEFAULT = 'default',
  CRITICAL = 'critical',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
  INFORMATION = 'information',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}
